import { userState } from "./types";

const setUser = (newState: userState): userState => {
	return newState;
};

const setAvatarSrc = (state: userState, avatarSrc: string): userState => {
	const newState: userState = {
		...state,
		avatarSrc: avatarSrc
	};

	return newState;
};

const actions = {
	setUser,
	setAvatarSrc
};

export {actions};